var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#04ABA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1495 15.4993C15.638 16.2433 15.0956 16.9692 14.2698 16.9812C13.4439 16.9992 13.1789 16.5072 12.2421 16.5072C11.2991 16.5072 11.0095 16.9692 10.2267 16.9992C9.41938 17.0292 8.80923 16.2073 8.29153 15.4813C7.23764 13.9994 6.43028 11.2696 7.51498 9.43371C8.05117 8.52177 9.01261 7.9458 10.0542 7.92781C10.8431 7.91581 11.595 8.44977 12.0819 8.44977C12.5626 8.44977 13.4747 7.80781 14.43 7.90381C14.8306 7.92181 15.9523 8.0598 16.6734 9.09173C16.6179 9.12773 15.336 9.85968 15.3483 11.3776C15.3668 13.1895 16.9815 13.7954 17 13.8014C16.9815 13.8434 16.7411 14.6654 16.1495 15.4993ZM12.6304 5.89994C13.0803 5.40197 13.826 5.024 14.4423 5C14.5224 5.70195 14.2328 6.40991 13.8014 6.91387C13.3761 7.42384 12.6735 7.81981 11.9832 7.76582C11.8908 7.07586 12.2359 6.35591 12.6304 5.89994Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIc);
export default __webpack_public_path__ + "static/media/apple-ic.10c06ee7fde4eb4763b508c49f43de5c.svg";
export { ForwardRef as ReactComponent };